import Button from "../../components/Button/Button";
import { FaSearch } from "react-icons/fa";
import Select from "../../components/Select/SearchableSelect";

const StudentSubjectFilter = ({
  student_count,
  changeHandler,
  fetchData,
  programData,
  program_id,
  subjectList,
  subject_id,
}) => {
  return (
    <div className="d-flex align-items-center flex-wrap gap-3">
      <div style={{ minWidth: 220, flex: "1 1 220px" }}>
        <Select
          name="program_id"
          id="program_id"
          placeholder="Select Class"
          onChangeHandler={(e) => changeHandler(e)}
          value={program_id}
          options={programData}
        />
      </div>
      {student_count === "2" && (
        <div style={{ minWidth: 220, flex: "1 1 220px" }}>
          <Select
            name="subject_id"
            id="subject_id"
            placeholder="Select Subject"
            onChangeHandler={(e) => changeHandler(e)}
            value={subject_id}
            options={subjectList}
          />
        </div>
      )}
      <Button variant="primary" type="button" onClick={fetchData} className="d-flex align-items-center gap-2">
        <FaSearch /> View
      </Button>
    </div>
  );
};

export default StudentSubjectFilter;
